import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
  requireProfile?: boolean;
}

export default function ProtectedRoute({ children, requireProfile = false }: ProtectedRouteProps) {
  const { authUser, currentUser, loading } = useAuth();

  if (loading) return null;

  if (!authUser) return <Navigate to="/SignIn" replace />;

  if (requireProfile && !currentUser) return <Navigate to="/onboarding" replace />;

  return <>{children}</>;
}
